import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';
import { PhotoService } from 'src/app/angularJS/services/photo/photo.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { CustomerDetailsService } from 'src/app/angularJS/services/customer-detail/customer-detail.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

export class CustomerCreateController {

  public static $inject = [
    '$rootScope',
    'customerService',
    'photoService',
    '$state',
    'UserMessages',
    '$translate',
    'ACTToolbarService',
    'customerDetailService',
    'customerConstants',
    'userService',
    'breadcrumbService'
  ];
  public photo;
  public titles: string;
  public customerStatus: string;
  public addressTypes: string;
  public contactTypes: string;
  public customer: InterACT.Interfaces.Customers.Customer;
  public schemes: Array<InterACT.Interfaces.Schemes.Scheme>;
  public regexList: any;
  public currentDate: Date;
  private selectedScheme: InterACT.Interfaces.Schemes.Scheme;

  constructor(
    private $rootScope,
    private customerService: CustomerService,
    private photoService: PhotoService,
    private $state: ng.ui.IStateService,
    private UserMessages: UserMessagesService,
    private $translate: ng.translate.ITranslateService,
    private toolbarService: ACTToolbarService,
    private customerDetailService: CustomerDetailsService,
    private customerConstants,
    private userService: UserService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.customerStatus = customerConstants.CUSTOMER_STATUS;
    this.titles = customerConstants.SALUTATIONS;
    this.addressTypes = customerConstants.ADDRESS_TYPES;
    this.contactTypes = customerConstants.CONTACT_TYPES;
    this.customer = <any>{};
    this.customer.addresses = [];
    this.customer.contactDetails = [];
    this.deleteContactDetail = customerDetailService.deleteContactDetail;
    this.regexList = customerConstants.REGEX_LIST;
    this.currentDate = new Date();
    this.activate();
  }

  public addAddress = (customer: InterACT.Interfaces.Customers.Customer) => {
    this.customerDetailService.addAddress(customer);
  }

  public addContactDetail = (customer: InterACT.Interfaces.Customers.Customer) => {
    this.customerDetailService.addContactDetail(customer);
  }

  public deleteAddress = (customer: InterACT.Interfaces.Customers.Customer, address: InterACT.Interfaces.Customers.CustomerAddress) => {
    this.customerDetailService.deleteAddress(customer, address);
  }

  public deleteContactDetail = (customer: InterACT.Interfaces.Customers.Customer, contactDetail: InterACT.Interfaces.Customers.CustomerContactDetail) => {
    this.customerDetailService.deleteContactDetail(customer, contactDetail);
  }

  public createCustomer = (schemaFields) => {
    this.$rootScope.showSpinner = true;
    if (angular.isDefined(schemaFields)) {
      this.customerDetailService.addSchemaFields(this.customer, schemaFields);
    }

    this.customer.contactDetails = _.filter(this.customer.contactDetails, (item) => {
      return item.detail !== '';
    });
    if (this.customer.contactDetails.length < 1) {
      delete this.customer.contactDetails;
    }
    if (this.customer.addresses.length < 1) {
      delete this.customer.addresses;
    }

    if (this.selectedScheme) {
      this.customer.scheme = {
        abbreviation: this.selectedScheme.reference,
        link: '/schemes/' + this.selectedScheme.id
      };
    }

    this.customer.title.toUpperCase();

    this.customerService.create(this.customer).then((response) => {
      this.UserMessages.showToast('TOAST_MESSAGE.CUSTOMER.CREATED');
      if (this.photo && (<any>response).headers.Location) {
        const seperatedURL = (<any>response).headers.Location.split('/');
        const newCustomerId = seperatedURL[seperatedURL.length - 1];
        this.createPhoto(this.photo, newCustomerId);
      } else {
        this.$rootScope.showSpinner = false;
        this.exitCreateCustomer();
      }
    });
  }

  public setPhoto = (data, name: string) => {
    this.photo = { data: data, name: name };
  }

  public createPhoto = (photoData, customerId: string) => {
    this.photoService.create(customerId, photoData.data, photoData.name).then(() => {
      this.$rootScope.showSpinner = false;
      this.UserMessages.showToast('PHOTOS.SUCCESS');
      this.exitCreateCustomer();
    });
  }

  public exitCreateCustomer = () => {
    this.$state.go('customers');
  }

  private activate() {
    this.toolbarService.getToolbar('primary').then((toolbar: any) => {
      toolbar.setTitle('Customer Create');
    });
    this.breadcrumbService.setBreadcrumbs([
      {
        name: 'Customers',
        sref: 'customers'
      }
    ]);
    this.selectedScheme = this.userService.selectedScheme;
    this.customerDetailService.addAddress(this.customer);
    this.customerDetailService.addContactDetail(this.customer);
  }
}